import { getInfrastructureArchitectureDiagramEndpointSelector } from "@/store/infrastructure-architecture/selectors/getInfrastructureArchitectureDiagramEndpointSelector";
import { RootState } from "@/store/store";
import { infrastructureArchitectureDiagramDataSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureDiagramDataSelector";

export const infrastructureArchitectureDiagramUninitializedSelector = (
  state: RootState,
) => {
  const data = infrastructureArchitectureDiagramDataSelector(state);

  return (
    getInfrastructureArchitectureDiagramEndpointSelector(state)
      ?.isUninitialized && !data
  );
};
